module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"finding_9":"Hauptabweichung","finding_3":"Nebenabweichung","finding_1":"Anmerkung","finding_0":"Bemerkung","cancel":"Abbrechen","save":"Speichern"},"en":{"audititem_title":"Audit Question","category_label":"Category","chapters_label":"Assigned Standard Chapters","importance_label":"Importance","cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
